<template>
  <div>
    <vs-button color="primary" class="mr-3" icon="check" @click="modal.visible = true"> Adicionar Mesas </vs-button>

    <a-modal title="Adicionar várias mesas" width="310px" v-model="modal.visible" :closable="false" :maskClosable="false" :zIndex="999999999">
      <ValidationObserver ref="frmMultiple">
        <div class="vx-row" v-show="!modal.processingData">        
          <div class="vx-col w-12/12">
            <ValidationProvider v-slot="{ errors }" rules="required|numeric" name="quantidade">
              <label>Quantidade</label>
              <a-input-number class="w-full" size="large" :min="1" :max="modal.maxRanger" v-model="modal.totalNumber" />
              <span class="text-danger">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row" v-show="modal.processingData">
          <div class="vx-col w-full">
            <label> {{ modal.lblProcessingData }} </label>
            <a-progress :percent="modal.progressTableInsert"  />
          </div>
        </div>
      </ValidationObserver>

      <template slot="footer">
        <!-- :disabled="modal.multiple.processingData" -->
        <a-button @click="modal.visible = false" > Cancelar </a-button>

        <a-button type="danger" @click="saveMultipleTableToFb" :loading="modal.processingData"> {{ modal.processingData ? 'Processando...' : 'Processar' }} </a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
import firebase from '@/firebase/firebase'
import _misc from '@/assets/utils/misc.js'

export default {
  props: {
    tables: {
      required: false,
      type: Array,
    },
  },

  data() {
    return {
      modal: {
        visible: false,
        processingData: false,
        maxRanger: 10,
        totalNumber: 0,
        lblProcessingData: '',
        progressTableInsert: 0,
        forceCancel: false,
      },
      ref : firebase.firestore(),
    }
  },
  methods: {
    async saveMultipleTableToFb () {
      try {
        let companyId = this.$store.getters.getCompanyID;
        let isValidForm = await this.$refs['frmMultiple'].validate()

        this.modal.forceCancel = false;

        if(isValidForm) {
          this.modal.processingData = true;

          // Get the last table number
          let lastTableNumber = parseInt(this.getLastTableNumber())

          for(let i = 0; i <= this.modal.totalNumber; i++) {
            if(this.modal.forceCancel) return

            let currentTableNumber = lastTableNumber + i;
            let generatedTableId = _misc.generateId(6, true)
            let shortUrl = await this.saveShortUrl(companyId, generatedTableId)
            let tableObj = {
              active : true,
              number : String(currentTableNumber).padStart(2, '0'),
              shortUrl : shortUrl,
              createdAt : new Date()
            }
            await this.ref.collection('company').doc(companyId).collection('tables').doc(generatedTableId).set(tableObj)

            this.modal.lblProcessingData = `Cadastrando mesa ${String(currentTableNumber).padStart(2, '0')}`;
            this.modal.progressTableInsert = Math.ceil((i * 100) / this.modal.totalNumber)
          }

          console.log('veio pra baixo')

          this.$message.success(`${this.modal.totalNumber} mesas foram inseridas no sistema com sucesso!`, 10)
        } else {
          console.log('valid?', isValidForm)
          throw new Error("Erro ao validar formulário")
        }
      } catch (err) {
        this.$message.error(`Houve um erro ao tentar processar a sua requisição: ${err.message}`, 13)
      } finally {
        this.modal.processingData = false;
        this.$vs.loading.close()
      }
    },

    getLastTableNumber () {
      let objTable = Object.values(this.tables)

      let newTableOrdered = objTable.sort((a, b) => b.number - a.number)

      return (newTableOrdered.length > 0 ? newTableOrdered[0].number : 0)
    },

    /**
     * shortUrl ID has the same table ID
     */
    async saveShortUrl (companyId, tableId) {
      let destLink = `https://pedidorapido.app/${companyId}/table/${tableId}`;

      let urlObj = {
        createdAt : _misc.getCurrentDate(),
        companyId : companyId,
        tableId : tableId,
        url : destLink,
        counters : {
          clicks : 0
        }
      }

      await this.ref.collection('shortUrls').doc(tableId).set(urlObj);
      // return `https://pedidorapido.app/code/${tableId}`
      return destLink
    },
  }
}
</script>
